import { Alert, Breadcrumb, Button, Col, Form, Input, Row, Select, Steps } from "antd";
import CWLayout from "../cwLayout";
import "./info-seller.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import ReactInputMask from "react-input-mask";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFormData, simcardPurchase } from "../../../../reducer/serviceReducer";
import { complexDigitToman, convertCurrencyToToman, regexFormater, validateInput } from "../../../../tools/tools";
import { useNavigate } from "react-router-dom";
import OTP from "../../../auxiliary/otp-modal/otp";
import Loading from "../../../auxiliary/loader/loading";

const CWINFOSeller = () => {
	const [t] = useTranslation("global");
	const [frmSeller] = Form.useForm();

	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const nav = useNavigate();

	const { queryCertType, queryOTPIsRequired } = useAPIPublic();
	const { isValidMSISDNToChangeOwner } = useDealer();

	const [certType, setCertType] = useState([]);
	const [isProgress, setIsProgress] = useState(false);
	const [isOpenOtp, setIsOpenOtp] = useState(false);
	const [smsMobile, setSmsMobile] = useState();

	const [isLoading, setIsLoading] = useState(false);

	const [isDepositAmount, setIsDepositAmount] = useState(false);

	const [msisdn, setMsisdn] = useState(0);

	const [billAmount, setBillAmount] = useState(0);
	const [purchaseProductId, setPurchaseProductId] = useState("");

	useEffect(() => {
		const intialService = async () => {
			if (certType?.length === 0) {
				setIsLoading(true);
				let response = await queryCertType();
				setCertType(response);
				setIsLoading(false);
			}
		};
		intialService();
	}, []);

	const handleSubmit = async (values) => {
		try {
			setIsLoading(true);
			dispatch(clearFormData(["changeownership"]));

			let payloadValid = {
				certtype: values.documenttype,
				msisdn: regexFormater(values.msisdn).removeSpace(),
				certno: values.certno,
			};
			let responseValid = await isValidMSISDNToChangeOwner(payloadValid);
			if (responseValid && !responseValid.HasError) {
				setPurchaseProductId(responseValid?.Result?.purchaseProductId);
				if (responseValid.Code === 1019) {
					if (responseValid?.Result?.billAmount > 0) {
						setBillAmount(parseInt(responseValid?.Result?.billAmount));
						setIsDepositAmount(true);
						setMsisdn(payloadValid.msisdn);
					}
				} else {
					let payload = {
						msisdn: regexFormater(values.msisdn).removeSpace(),
						certno: values.certno,
						certtype: values.documenttype,
					};
					let resValid = await queryOTPIsRequired(payload);
					if (resValid) {
						if (resValid.otpIsRequired) {
							setSmsMobile(regexFormater(values.smsmobile).removeSpace());
							setIsOpenOtp(true);
							setIsProgress(true);
							return;
						} else {
							dispatch(
								simcardPurchase({
									changeownership: {
										seller: {
											documenttype: values.documenttype,
											certno: payload.certno,
											msisdn: regexFormater(values.msisdn).removeSpace(),
											smsmobile: regexFormater(values.smsmobile).removeSpace(),
											purchaseProductId: responseValid?.Result?.purchaseProductId,
										},
									},
								}),
							);
							nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Profile);
						}
					}
				}
			}

			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleCallBackOtp = (token) => {
		setIsOpenOtp(false);
		if (token) {
			dispatch(
				simcardPurchase({
					changeownership: {
						seller: {
							token: token?.token,
							documenttype: frmSeller.getFieldValue("documenttype"),
							certno: frmSeller.getFieldValue("certno"),
							msisdn: regexFormater(frmSeller.getFieldValue("msisdn")).removeSpace(),
							smsmobile: regexFormater(frmSeller.getFieldValue("smsmobile")).removeSpace(),
							purchaseProductId: purchaseProductId,
						},
					},
				}),
			);
			nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Profile);
		}
	};
	return (
		<CWLayout>
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={0}
										responsive
										items={[
											{
												title: "اطلاعات فروشنده",
											},
											{
												title: "اطلاعات خریدار",
											},
											{
												title: "آپلود مدرک شناسایی",
											},
											{
												title: "پیش فاکتور",
											},
											{
												title: "سند",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-information-seller">
								<div className="holder-form">
									<Form id="frmSeller" form={frmSeller} layout="vertical" onFinish={handleSubmit}>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="documenttype"
													label="نوع مدرک شناسایی"
													rules={[validateInput({ t: t, validate: true })]}>
													<Select placeholder="نوع مدرک شناسایی">
														{certType?.map((item, key) => (
															<Select.Option key={key} value={item.value}>
																{item.name}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													label="شماره مدرک شناسایی"
													name="certno"
													rules={[validateInput({ t: t, validate: true, length: 10, type: "number" })]}>
													<Input dir="ltr" autoComplete="off" placeholder="شماره مدرک شناسایی را وارد کنید" maxLength={10} />
												</Form.Item>
											</Col>
										</Row>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													label="شماره همراه آپتلی"
													name="msisdn"
													rules={[
														validateInput({
															t: t,
															validate: true,
															type: "msisdnOrg",
														}),
													]}>
													<div>
														<ReactInputMask dir="ltr" className="msisdn-mask" mask="0\9\9\91 99 99 99" />
													</div>
												</Form.Item>
											</Col>
										</Row>
										<p>جهت ارسال رمز یکبار مصرف شماره آپتلی و یا شماره ای که به نام خود دارید را وارد کنید.</p>
										<Row gutter={30}>
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item
													className="input-normal"
													name="smsmobile"
													label="شماره همراه "
													rules={[validateInput({ t: t, validate: true, type: "msisdnOrg" })]}>
													<div>
														<ReactInputMask dir="ltr" className="msisdn-mask" mask="0\999 999 99 99" />
													</div>
												</Form.Item>
											</Col>
										</Row>
									</Form>
									{isDepositAmount && (
										<Row>
											<Col xxl={10} xl={10} lg={12} md={20} sm={24} xs={24}>
												<Alert
													message="خطا در عملیات"
													type="error"
													description={
														<>
															<div className="holder_alert_payment">
																<ul>
																	<li>
																		<div className="label">نوع مشترک:</div>
																		<div className="value">دائمی</div>
																	</li>
																</ul>

																<div className="holder_alert">
																	<div className="payment_alert">
																		<span dir="ltr">{complexDigitToman(billAmount)}</span> تومان
																	</div>
																	<div className="holder-button">
																		<Button
																			onClick={(e) =>
																				nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill, {
																					state: {
																						msisdn: msisdn,
																					},
																				})
																			}
																			className="btn-normal btn-aptel">
																			پرداخت بدهی
																		</Button>
																	</div>
																</div>
																<div className="holder_message_alert">
																	<p>
																		جهت تسویه میتوانید از طریق گزینه <span>پرداخت بدهی</span> اقدام نمایید. یا از مشترک درخواست نمایید بدهی خود را از
																		درگاه آپتل به نشانی aptel.ir پرداخت نماید.
																	</p>
																</div>
															</div>
														</>
													}
												/>
											</Col>
										</Row>
									)}
								</div>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button form="frmSeller" key="submit" htmlType="submit" className="btn-normal btn-aptel" disabled={isProgress}>
									مرحله بعد
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<OTP
				isOpen={isOpenOtp}
				checkmsisdnvcertno={true}
				certno={frmSeller.getFieldValue("certno")}
				expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
				msisdn={smsMobile?.slice(1)}
				sessionid={Date.now()}
				callback={handleCallBackOtp}
			/>
			<Loading isOpen={isLoading} />
		</CWLayout>
	);
};

export default CWINFOSeller;
